import Axios from 'axios';

const apiUpload = Axios.create({
  baseURL: process.env.VUE_APP_UPLOAD_API_URL,
});

export default apiUpload;
